module.exports = __webpack_public_path__ + "img/cloth_g3_item-10.81c046ba.svg";